export const HEADER_VIEW_HEIGHT = 65;
export const LOGO_IMAGE_PADDING = 40;
export const PADDING_MENU_CONTENT = 10;
export const DROPDOWN_ROUTE_WRAPPER_HEIGHT = 55;
export const NORMAL_ROUTE_WRAPPER_HEIGHT = 45;
export const ACTIVE_LIGHTNESS = 0.2;
export const ANIMATION_DURATION_MS = 250;
export const MENU_MIN_WIDTH = 123;
export const MENU_ITEM_WIDTH = 245;
export const NORMAL_MENU_ITEM_HORIZONTAL_MARGIN = 23;
export const MENU_ITEM_VERTICAL_MARGIN = 10;